import { useAtomValue } from 'jotai';
import Image from 'next/image';
import * as React from 'react';
import { useTranslation } from 'next-i18next';

import { customImageLoader, imageVariant } from '@restworld/utils-common';

import { restaurantDetailsAtom, ShowcaseSectionTitle } from '.';

const VenueOwnerMessage: React.FC = () => {
  const restaurantDetails = useAtomValue(restaurantDetailsAtom);
  const venueOwnerData = restaurantDetails?.venueOwnerData;
  const { t } = useTranslation('restaurant-showcase-v2');

  if (!venueOwnerData?.ownerMessage) return <></>;

  return (
    <div className="self-stretch inline-flex flex-col justify-start items-start gap-4">
      <div className="self-stretch inline-flex justify-start items-center gap-4">
        {!!venueOwnerData.ownerProfilePicture && (
          <div className="w-16 h-16 overflow-hidden relative">
            <Image
              alt="owner-pic"
              fill
              className="rounded-full object-cover object-top"
              src={imageVariant(venueOwnerData.ownerProfilePicture, 'sm') ?? venueOwnerData.ownerProfilePicture}
              loader={customImageLoader}
            />
          </div>
        )}
        <ShowcaseSectionTitle title={t('message_from_the_owner')} />
      </div>
      <div className="self-stretch justify-start">
        <h5 className="text-neutral-700 text-base font-normal">“{venueOwnerData.ownerMessage}”</h5>
        {venueOwnerData.ownerName && (
          <h5 className="text-neutral-700 text-base font-bold">{venueOwnerData.ownerName}</h5>
        )}
      </div>
    </div>
  );
};

export default VenueOwnerMessage;
